export default function LogoCloud() {
    return (
    <div className="relative mx-auto lg:mx-12 max-w-lg  lg:max-w-full" >
    <h2 className="text-3xl font-mathsans tracking-tight text-gray-900 sm:text-3xl">Our clients</h2>
    <p className="mt-3 text-xl text-gray-500 sm:mt-4">
              <p className="mt-3 text-xl text-gray-500 sm:mt-3 ">
              We believe brands are the cultural connection between companies and their communities.
            </p>
            </p>
      <div className="bg-white">
        <div className="mx-auto lg:mx-12 max-w-full py-12 px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 gap-8 md:grid-cols-6 lg:grid-cols-5">
            <div className="col-span-1 flex justify-center md:col-span-2 lg:col-span-1">
              <img className="h-12" src="https://cdn-icons-png.flaticon.com/256/25/25412.png" alt="Tuple" />
            </div>
            <div className="col-span-1 flex justify-center md:col-span-2 lg:col-span-1">
              <img className="h-12" src="https://cdn-icons-png.flaticon.com/256/882/882834.png" alt="Mirage" />
            </div>
            <div className="col-span-1 flex justify-center md:col-span-2 lg:col-span-1">
              <img className="h-12" src="https://i.pinimg.com/736x/77/2c/be/772cbe294ba09b4e16119835b596a0fd.jpg" alt="StaticKit" />
            </div>
            <div className="col-span-1 flex justify-center md:col-span-3 lg:col-span-1">
              <img
                className="h-12  "src="https://cdn-icons-png.flaticon.com/256/732/732084.png" alt="Transistor"/>
            </div>
            <div className="col-span-2 flex justify-center md:col-span-3 lg:col-span-1">
              <img
                className="h-12"
                src="https://cdn-icons-png.flaticon.com/256/5968/5968219.png"
                alt="Workcation"
              />
            </div>
            <div className="col-span-2 flex justify-center md:col-span-3 lg:col-span-1">
              <img
                className="h-12"
                src="https://i.pinimg.com/736x/ad/38/54/ad3854b3b9e1c93353807ebbd0c47e03.jpg"
                alt="Workcation"
              />
            </div>
            <div className="col-span-2 flex justify-center md:col-span-3 lg:col-span-1">
              <img
                className="h-12"
                src="https://i.pinimg.com/736x/b5/2f/c9/b52fc93b79685d685cbd7b74486d15f0.jpg"
                alt="Workcation"
              />
            </div>
            <div className="col-span-2 flex justify-center md:col-span-3 lg:col-span-1">
              <img
                className="h-12"
                src="https://i.pinimg.com/736x/fd/ad/1d/fdad1d55df9be1bb270aefc22c8e6f8b.jpg"
                alt="Workcation"
              />
            </div>
            <div className="col-span-2 flex justify-center md:col-span-3 lg:col-span-1">
              <img
                className="h-12"
                src="https://i.pinimg.com/736x/db/38/5b/db385b1e43bd2350f102c3e95ef67de6.jpg"
                alt="Workcation"
              />
            </div>
            <div className="col-span-2 flex justify-center md:col-span-4 lg:col-span-1">
              <img
                className="h-12"
                src="https://cdn-icons-png.flaticon.com/256/16183/16183560.png"
                alt="Workcation"
              />
            </div>
          </div>
        </div>
      </div>
      </div> 
    )
  }